module.exports = __webpack_public_path__ + "static/media/Search.56dd92fe.svg";